import { createApp } from 'vue'
import App from './App.vue'
import naive from 'naive-ui'
import router from './router'
// 通用字体
import 'vfonts/Lato.css'
// 等宽字体
import 'vfonts/FiraCode.css'
import SignalRClient from './ts/SignalRClient'

//#region 连接到服务器
SignalRClient.Instance.StartAsync().then(() => {
    const app = createApp(App);
    app.use(naive);
    app.use(router);
    app.mount('#app')
});
//#endregion


